import _ from 'lodash'

// Initial State
import { nodes as initialState } from '_initialStates'

// Utils
import {
  changeCurrentNodeInformation,
  changeIsFetching,
  changeRootNodeTitle,
  changeToEditing,
  fetched,
  fetching,
  setNewCurrentNode,
  setNewNodeObject,
  setNewNodes,
  setNewParentNode,
} from 'utils/nodes'

// Action Types
export const FETCHING_NODES = 'FETCHING_NODES'
export const FETCHED_NODES = 'FETCHED_NODES'
export const FETCHED_NODE = 'FETCHED_NODE'

// Reducer
export function nodes(state = initialState({}), action) {
  switch (action.type) {
    case 'CHANGE_CURRENT_NODE_INFORMATION' :
      return changeCurrentNodeInformation(state, action)
    case 'CHANGE_IS_FETCHING' :
      return changeIsFetching(state, action)
    case 'CHANGE_ROOT_NODE_TITLE' :
      return changeRootNodeTitle(state, action)
    case 'CHANGE_TO_EDITTING' :
      return changeToEditing(state, action)
    case 'FETCHED_NODES' :
      return fetched(state, action)
    case 'FETCHING_NODES' :
      return fetching(state, action)
    case 'SET_NEW_CURRENT_NODE' :
      return setNewCurrentNode(state, action)
    case 'SET_NEW_NODE_OBJECT' :
      return setNewNodeObject(state, action)
    case 'SET_NEW_NODES' :
      return setNewNodes(state, action)
    case 'SET_NEW_PARENT_NODE' :
      return setNewParentNode(state, action)
    default:
      return state
  }
}

export function loadedNodes(state = {isFetching: false, data: []}, action) {
  switch (action.type) {
    case 'FETCHED_NODE' :
      return {
        isFetching: false,
        data: _.uniqBy([
          ...state.data,
          action.node,
        ])
      }
    case 'FETCHING_NODES' :
      return {
        isFetching: true,
        data: state.data,
      }
    default:
      return state
  }
}
